/* eslint-disable i18next/no-literal-string */
import { Box } from "@outschool/backpack";
import {
  ActivityEnrollableTimesModal_ActivityFragment,
  ClassDetailsNoSectionsQuery,
  ClassDetailsQuery_ActivityFragment,
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import MobileActivityPrice from "./MobileActivityPrice";
import { AskAQuestionButtonMemo } from "./ClassDetailsMainBody/Buttons";
import { useTrackEvent } from "@outschool/ui-analytics";
import { useSession } from "@outschool/ui-auth";
import { useShowCredits } from "../Subscriptions";
import MobileActivityCredits from "./MobileActivityCredits";

export default function MobileStickyFooter({
  activity,
  hasOneOnOneAvailabilities = false,
  button,
  hideMobileStickyFooter = false,
  TutorEnrollButton,
  activityWithEnrollableTimes,
  leader,
  MessageModal,
}: {
  activity: ClassDetailsQuery_ActivityFragment;
  hasOneOnOneAvailabilities?: boolean;
  button: React.ReactElement;
  hideMobileStickyFooter?: boolean;
  TutorEnrollButton?: React.ElementType;
  activityWithEnrollableTimes?: ActivityEnrollableTimesModal_ActivityFragment;
  leader: ClassDetailsNoSectionsQuery["activity"]["leader"];
  MessageModal: React.ElementType;
}) {
  const { t } = useTranslation(
    "ui-components-website\\ClassDetailsPage\\MobileStickyFooter"
  );
  const { currentUser, isLoggedIn } = useSession();
  const trackEvent = useTrackEvent();
  const showCredits = useShowCredits();

  return (
    <Box
      flex
      sx={{
        width: "100%",
        zIndex: 1000,
        backgroundColor: "white",
        padding: "20px 16px",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow:
          "0px -8px 16px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.04);",
        borderTop: "1px solid",
        borderColor: "grey.200",
        position: "fixed",
        bottom: hideMobileStickyFooter ? -500 : 0,
        opacity: hideMobileStickyFooter ? "0" : "1",
        transition: "all 0.3s ease-in-out",
        columnGap: "1em",
      }}
    >
      {showCredits ? (
        <MobileActivityCredits activity={activity} />
      ) : (
        <MobileActivityPrice activity={activity} />
      )}
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
        {hasOneOnOneAvailabilities && TutorEnrollButton ? (
          <TutorEnrollButton
            activity={activity}
            buttonText={t("See Schedule")}
            buttonSize={"small"}
            activityWithEnrollableTimes={activityWithEnrollableTimes}
          />
        ) : (
          button
        )}
        {isLoggedIn && (
          <AskAQuestionButtonMemo
            activity={activity}
            currentUser={currentUser}
            isLoggedIn={isLoggedIn}
            leader={leader}
            trackEvent={trackEvent}
            MessageModal={MessageModal}
            useShortText={true}
            buttonSize={"small"}
            useIconOnly={true}
          />
        )}
      </Box>
    </Box>
  );
}
